import { IColumn } from '../../../core/components/Table'
import { formatDateTime } from '../../../core/constants/times'

const topUpColumnSerial: IColumn[] = [
  {
    title: 'Top-Up Order',
    accessor: 'providerPaymentId',
    sortable: true,
  },
  {
    title: 'Serial Number',
    accessor: 'backstageWristbandId',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'Amount',
    accessor: 'amount',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.createdAt)}</span>,
  },
  {
    title: 'Paid',
    accessor: 'status',
    sortable: true,
    render: (row) => <span>{row.status.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Cancel Reason',
    accessor: 'cancelReason',
    sortable: true,
  },
  {
    title: 'Description',
    accessor: 'type',
    sortable: true,
    render: (row) => <span>{row.type.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Backstage Synced',
    accessor: 'syncBackstage',
    sortable: true,
    render: (row) =>
      row.syncBackstage ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Festipay Synced',
    accessor: 'syncedOnWristband',
    sortable: true,
    render: (row) =>
      row.syncedOnWristband ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Event',
    accessor: 'festivalEdition',
    sortable: true,
    render: (row) => (
      <span style={{ color: '#198754' }}>{row.festivalEdition}</span>
    ),
  },
]

const topUpColumnBarcode: IColumn[] = [
  {
    title: 'Top-Up Order',
    accessor: 'providerPaymentId',
    sortable: true,
  },
  {
    title: 'Serial Number',
    accessor: 'backstageWristbandId',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'Amount',
    accessor: 'amount',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.createdAt)}</span>,
  },
  {
    title: 'Paid',
    accessor: 'status',
    sortable: true,
    render: (row) => <span>{row.status.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Cancel Reason',
    accessor: 'cancelReason',
    sortable: true,
  },
  {
    title: 'Description',
    accessor: 'type',
    sortable: true,
    render: (row) => <span>{row.type.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Backstage Synced',
    accessor: 'syncBackstage',
    sortable: true,
    render: (row) =>
      row.syncBackstage ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Festipay Synced',
    accessor: 'syncedOnWristband',
    sortable: true,
    render: (row) =>
      row.syncedOnWristband ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Event',
    accessor: 'festivalEdition',
    sortable: true,
    render: (row) => (
      <span style={{ color: '#198754' }}>{row.festivalEdition}</span>
    ),
  },
]

const topUpColumnEmail: IColumn[] = [
  {
    title: 'Top-Up Order',
    accessor: 'providerPaymentId',
    sortable: true,
  },
  {
    title: 'Serial Number',
    accessor: 'backstageWristbandId',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'Amount',
    accessor: 'amount',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.createdAt)}</span>,
  },
  {
    title: 'Paid',
    accessor: 'status',
    sortable: true,
    render: (row) => <span>{row.status.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Cancel Reason',
    accessor: 'cancelReason',
    sortable: true,
  },
  {
    title: 'Description',
    accessor: 'type',
    sortable: true,
    render: (row) => <span>{row.type.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Backstage Synced',
    accessor: 'syncBackstage',
    sortable: true,
    render: (row) =>
      row.syncBackstage ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Festipay Synced',
    accessor: 'syncedOnWristband',
    sortable: true,
    render: (row) =>
      row.syncedOnWristband ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Event',
    accessor: 'festivalEdition',
    sortable: true,
    render: (row) => (
      <span style={{ color: '#198754' }}>{row.festivalEdition}</span>
    ),
  },
]

const topUpColumnTopup: IColumn[] = [
  {
    title: 'Top-Up Order',
    accessor: 'providerPaymentId',
    sortable: true,
  },
  {
    title: 'Serial Number',
    accessor: 'backstageWristbandId',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
  },
  {
    title: 'Amount',
    accessor: 'amount',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'createdAt',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.createdAt)}</span>,
  },
  {
    title: 'Paid',
    accessor: 'status',
    sortable: true,
    render: (row) => <span>{row.status.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Cancel Reason',
    accessor: 'cancelReason',
    sortable: true,
  },
  {
    title: 'Description',
    accessor: 'type',
    sortable: true,
    render: (row) => <span>{row.type.replaceAll('_', ' ')}</span>,
  },
  {
    title: 'Backstage Synced',
    accessor: 'syncBackstage',
    sortable: true,
    render: (row) =>
      row.syncBackstage ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Festipay Synced',
    accessor: 'syncedOnWristband',
    sortable: true,
    render: (row) =>
      row.syncedOnWristband ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Event',
    accessor: 'festivalEdition',
    sortable: true,
    render: (row) => (
      <span style={{ color: '#198754' }}>{row.festivalEdition}</span>
    ),
  },
]

export const getTopUpColumn = (
  searchBy: 'serial' | 'barcode' | 'email' | 'topupOrder',
) => {
  switch (searchBy) {
    case 'serial':
      return topUpColumnSerial
    case 'barcode':
      return topUpColumnBarcode
    case 'email':
      return topUpColumnEmail
    case 'topupOrder':
      return topUpColumnTopup
    default:
      return topUpColumnSerial
  }
}
